import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddDesignation() {
    const [designation, setDesignation] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!designation) return toast.error("Designation should not be empty")


        const data = {
            name: designation,
        };
        try {
            const res = await HomeService.addDesignation(data);
            if (res?.status) {
                toast.success("Designation added successfully!");
                clearAddForm();
                navigate("/manage-designation");
            }
        } catch (error) {
            toast.error("Failed to add Designation.");
            console.error("Error adding Designation:", error);
        }
    };

    const clearAddForm = () => {
        setDesignation("");
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">
                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Designation
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="designation">
                                        Designation<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="designation"
                                        className="form-control"
                                        value={designation}
                                        onChange={(e) => setDesignation(e.target.value)}
                                        placeholder="Enter Designation"
                                        required
                                    />
                                </div>
                            </div>
                            <button type="submit"   style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }} className="btn mt-3">
                                Add
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddDesignation;
